import React from "react";
import { ArrowRight, Calendar, Sparkles } from "lucide-react";

export default function Hero() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section 
      id="acasa"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center justify-center overflow-hidden bg-black"
    >
      {/* Background Visual Loop / Image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/90 z-10" />
        <img
          src="https://customer-assets.emergentagent.com/job_luxury-events-sibiu/artifacts/6ej9lec9_5C615569-3220-4EAD-A3A2-26E7CB1F8B5F.png"
          alt="Sala de evenimente Elysium Events Sibiu"
          className="w-full h-full object-cover object-center transform scale-105 animate-[pulse_10s_infinite_alternate]"
        />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-10">
        <div className="inline-flex items-center space-x-2 bg-white/5 border border-white/10 backdrop-blur-md px-4 py-2 rounded-full mb-6">
          <Sparkles size={14} className="text-[#D4AF37]" />
          <span className="text-[10px] sm:text-xs text-[#EEDC82] tracking-[0.25em] uppercase font-medium">
            Locație de 5 Stele în Sibiu
          </span>
        </div>

        <h1 
          data-testid="hero-title"
          className="font-serif-lux text-4xl sm:text-6xl lg:text-7xl text-white font-medium leading-[1.1] tracking-tight mb-6"
        >
          Transformăm momentele speciale în <span className="text-[#D4AF37] italic font-normal">experiențe memorabile</span>
        </h1>

        <p 
          data-testid="hero-subtitle"
          className="text-base sm:text-xl text-[#F3E5D8] max-w-2xl mx-auto mb-10 font-light leading-relaxed"
        >
          Locația perfectă pentru nunți, botezuri, aniversări și evenimente corporate în Sibiu. Un cadru de poveste unde luxul întâlnește eleganța.
        </p>

        {/* Buttons / Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <button
            data-testid="hero-request-offer-btn"
            onClick={() => {
              const element = document.getElementById("contact");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
                // If contact element has tabs, we want to select the offer request tab
                const offerTab = document.getElementById("tab-trigger-oferta");
                if (offerTab) offerTab.click();
              }
            }}
            className="w-full sm:w-auto bg-[#D4AF37] text-black hover:bg-[#C5A880] text-sm font-semibold tracking-widest uppercase py-5 px-10 transition-all duration-300 flex items-center justify-center space-x-2 group"
          >
            <span>Solicită Ofertă</span>
            <ArrowRight size={16} className="transform group-hover:translate-x-1 transition-transform" />
          </button>

          <button
            data-testid="hero-schedule-visit-btn"
            onClick={() => {
              const element = document.getElementById("contact");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
                // select the viewing trigger
                const visitTab = document.getElementById("tab-trigger-vizionare");
                if (visitTab) visitTab.click();
              }
            }}
            className="w-full sm:w-auto border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10 text-sm font-semibold tracking-widest uppercase py-5 px-10 transition-all duration-300 flex items-center justify-center space-x-2"
          >
            <Calendar size={16} />
            <span>Programează o Vizionare</span>
          </button>
        </div>
      </div>

      {/* Elegant scroll indicator */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-20 hidden sm:flex flex-col items-center space-y-2 opacity-60">
        <span className="text-[9px] tracking-[0.3em] text-white/55 uppercase font-medium">Scroll down</span>
        <div className="w-[1px] h-10 bg-gradient-to-b from-white/60 to-transparent animate-bounce" />
      </div>
    </section>
  );
}
